import { render, staticRenderFns } from "./ProductObtaining.vue?vue&type=template&id=3e2d70f3&scoped=true&lang=pug&"
import script from "./ProductObtaining.vue?vue&type=script&lang=ts&"
export * from "./ProductObtaining.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2d70f3",
  null
  
)

export default component.exports